// Module
var code = "<h3>User</h3> <div class=\"card\"> <h5>User Profile</h5> <hr/> <div id=\"user-form\" class=\"grid pt-8\"> </div> </div> <div class=\"flex justify-end items-center\"> <button id=\"updateProfileBtn\" onclick=\"thsTab.addUser()\" class=\"mt-8\">Update user</button> </div> ";
// Exports
export default code;